import React from 'react'

export default function Header() {
    return (
        <div className="header-card">
            <h1>Country Quiz</h1>
        </div>
    )
}
